<template>
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3 4C3 3.44772 3.44772 3 4 3H10C10.5523 3 11 3.44772 11 4V10C11 10.5523 10.5523 11 10 11H4C3.44772 11 3 10.5523 3 10V4Z"
            fill="currentColor"
        />
        <path
            d="M13 4C13 3.44772 13.4477 3 14 3H20C20.5523 3 21 3.44772 21 4V10C21 10.5523 20.5523 11 20 11H14C13.4477 11 13 10.5523 13 10V4Z"
            fill="currentColor"
        />
        <path
            d="M3 14C3 13.4477 3.44772 13 4 13H10C10.5523 13 11 13.4477 11 14V20C11 20.5523 10.5523 21 10 21H4C3.44772 21 3 20.5523 3 20V14Z"
            fill="currentColor"
        />
        <path d="M17.8 13H16.2V16.2H13V17.8H16.2V21H17.8V17.8H21V16.2H17.8V13Z" fill="currentColor" />
    </svg>
</template>

<script>
export default {
    name: "AppStoreIcon"
};
</script>
